import { BehaviorSubject, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { DebugPanelItem } from '../types';
import { isDevOrStaging } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class DebugPanelRegistryService {
  private readonly _items$ = new BehaviorSubject<DebugPanelItem[]>([]);
  public get isEnabled(): boolean {
    return isDevOrStaging();
  }

  public get items$(): Observable<DebugPanelItem[]> {
    return this._items$.asObservable();
  }

  public get items(): DebugPanelItem[] {
    return this._items$.value;
  }

  public register(items: DebugPanelItem | DebugPanelItem[]): void {
    if (!this.isEnabled) {
      return;
    }
    const itemsArray = Array.isArray(items) ? items : [items];
    const currentItems = this._items$.value;
    const newItems = itemsArray.filter((item) => !currentItems.some((i) => i.id === item.id));

    this._items$.next([...currentItems, ...newItems]);
  }

  public unregister(ids: string | string[]): void {
    const idsArray = Array.isArray(ids) ? ids : [ids];
    const currentItems = this._items$.value;
    const filteredItems = currentItems.filter((item) => !idsArray.includes(item.id));

    if (filteredItems.length !== currentItems.length) {
      this._items$.next(filteredItems);
    }
  }

  public clear(): void {
    this._items$.next([]);
  }
}
